import React from 'react';
import classnames from 'classnames';

import Typography from 'components/uiLibrary/Typography';
import LinkButton from 'components/uiLibrary/LinkButton';

import useNavigate from 'utils/hooks/useNavigate';
import { createDate } from 'utils/date';
import { SUB_COMPONENTS } from 'components/Globals/Analytics/constants';
import { DATE_FORMATS, PERFORMANCE_DATE_MODE_TYPES } from 'constants/index';
import { ENTITY_TYPES } from 'operabase-router/constants';

import classes from './Dates.module.scss';

const Dates = ({ dates, month, year, isCancelled, shouldShowYear = true, entity, trackingData }) => {
  const navigate = useNavigate();

  return (
    <div className={classes.root}>
      {shouldShowYear && (
        <Typography weight="medium" size={12}>
          {year}
        </Typography>
      )}
      <div className={classes.dates}>
        <Typography size={12} className={classes.dates__month}>
          {createDate(month, DATE_FORMATS.FULL_MONTH).format(DATE_FORMATS.MONTH_ABBR)}
        </Typography>
        <div className={classes.dates__list}>
          {dates?.map((date, index) => {
            if (!date?.startDate) {
              return null;
            }

            const dateObj = createDate(date?.startDate, DATE_FORMATS.FULL_DATE);
            const linkProps = navigate.getLinkProps({
              entityType: ENTITY_TYPES.PRODUCTION,
              entity,
              path: dateObj.locale('en').format(DATE_FORMATS.URL_FULL_DATE),
            });

            return (
              <div
                className={date?.isCancelled || isCancelled ? classes.cancelled : ''}
                key={`${dateObj?.format?.(DATE_FORMATS.FULL_DATE)}-${index}`}
              >
                <LinkButton
                  variant="text"
                  styles={{ root: classes.dates__item }}
                  trackingData={{
                    ...trackingData,
                    subComponent: trackingData?.subComponent || SUB_COMPONENTS.DATE,
                    entityId: entity?.id,
                    entityName: entity?.name,
                    entityType: ENTITY_TYPES.PRODUCTION,
                    meta: {
                      ...trackingData?.meta,
                      performanceId: date?.id,
                      performanceDate: date?.startDate,
                    },
                  }}
                  isLink
                  {...linkProps}
                  disableUnderline
                  target="_blank"
                >
                  {' '}
                  <time
                    className={classnames(classes.dateTime, {
                      [classes.dateTimeBold]: !!date?.isPerformed,
                      [classes.dateTimeMT]: !!date?.isMatinee || !!date?.isTour,
                    })}
                    dateTime={dateObj?.format(DATE_FORMATS.FULL_DATE)}
                  >
                    {date.id !== -1 ? dateObj?.format(DATE_FORMATS.DATE) : date?.startTime}
                  </time>
                  {date?.isMatinee && (
                    <Typography size="12" color="secondary" italic className={classes.dates__itemSubText}>
                      m
                    </Typography>
                  )}
                  {date?.isTour && (
                    <Typography size="12" color="secondary" italic className={classes.dates__itemSubText}>
                      t
                    </Typography>
                  )}
                  {date?.mode === PERFORMANCE_DATE_MODE_TYPES.LIVESTREAM && (
                    <Typography size="12" color="secondary" italic className={classes.dates__itemSubText}>
                      ls
                    </Typography>
                  )}
                  {index !== dates.length - 1 && <Typography>{', '}</Typography>}
                </LinkButton>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Dates;
